
const authentication = require('../../../react-azure-adb2c2').default;
export const task = (values: any) => {

    // const url = `http://localhost:5000/v1/rent/customer/contacts/task`;
    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/rent/customer/contacts/task`;
    // const url = `https://crmapi-docker-610239673051.asia-northeast1.run.app/v1/rent/customer/contacts/task`;

    // alert(url)
    const token = authentication.getAccessToken();
    //const search = values ? values : {};
    // alert(JSON.stringify(values))

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}

